import button from './assets/button.mp3';
import slide from './assets/slide.mp3';

export const playSound = ((src: string): () => Promise<void> => {
  let sound: {
    play: () => void
  };

  return async () => {
    if (!sound) {
      const { Howl } = await import('howler');
      sound = new Howl({
        src: [src],
      });
    }

    sound.play();
  };
});

export const playButtonSound = playSound(button);
export const playSlideSound = playSound(slide);
